const queryRules = {
  en: {
    queryRules: {
      rule_title: "Rules",
      query_rules: "Query Rules",
      create_query_rule: "Create Query Rule",
      edit_query_rule: "Edit Query Rule",
      query_name_star: "Query Name *",
      provide_query_name: "Please provide query name",
      select_actions: "Please select one or more actions.",
      create_new_rule: "Create New Rule",
      no_rule_created: "No rules have been created.",
      all_loaded: "All query rules are loaded.",
      total_rules: "Total Rules Count: ",
      modal: {
        header: "Set Tag Content",
        value: "Value:",
        negate: "Negate:",
        top: "top",
        bottom: "bottom",
        select: "Select",
        characters: "characters",
        percent:"percent",
        paragraphs:"paragraphs",
        value_cannot_be_empty: "Value cannot be empty",
        limit_cannot_be_empty: "You cannot select a characters limit to 0 or less",
        value_already_exists: "Value already exists",
        invalid_query: "Invalid query",
      },
      tags: {
        placeholder: {
          add_source: "Select one or more source(s)",
          add_author: "Select an author",
          add_tag: "Select a tag",
          default: "Select an option"
        },
        impression_value: "Set the impression value",
        text_value: "Enter the text you want",
        select_action: "Select an action",
        error_no_action: "You have to select at least one Action."
      },
      filters: {
        and: "AND",
        or: "OR"
      },
      dragDrop: {
        here: "Drag Filter Here...",
        not_allowed: "Drag Not Allowed"
      },
      crud: {
        create: {
          title: 'Create Query Rule',
          success: 'Query Rule created successfully',
          error: 'Error creating Query Rule'
        },
        get: {
          title: 'Query Rule',
          error: 'Error fetching Query Rule'
        },
        update: {
          title: 'Update Query Rule',
          success: 'Query Rule updated successfully',
          error: 'Error updating Query Rule'
        },
        delete: {
          title: 'Delete Query Rule',
          success: 'Query Rule deleted successfully',
          error: 'Error deleting Query Rule'
        }
      }
    }
  }
};

module.exports.queryRules = queryRules;